export default "/images/4429aa33ad52a7718472486f224526b4.avif";